import { useSettingsStore } from '@supsupclub/ui-components';

import { PrivacyDe } from './privacy-de';
import { PrivacyEn } from './privacy-en';
import { PrivacyNl } from './privacy-nl';
import { PrivacyPt } from './privacy-pt';

const privacyComponents = {
  en: PrivacyEn,
  de: PrivacyDe,
  pt: PrivacyPt,
  nl: PrivacyNl,
};

export const Privacy = () => {
  const locale = useSettingsStore((store) => store.locale);
  const Component = privacyComponents[locale] ?? privacyComponents.en;
  return <Component />;
};
